import * as React from 'react';

export type CodeBlockOverflowMode = 'scroll' | 'wrap';

export interface CodeBlockLayoutOptions {
    /**
     * Control how the code block should overflow.
     */
    overflow: CodeBlockOverflowMode;

    /**
     * Control the rendering of line-numbers in the gutter.
     * - `false`: Do not render line-numbers.
     * - `true`: Render line-numbers.
     * - number: Render line-numbers starting at the specified number.
     * @default false
     */
    lineNumbers: boolean | number;
}

export const CodeBlockLayoutContext = React.createContext<CodeBlockLayoutOptions>({
    overflow: 'scroll',
    lineNumbers: false,
});
